import { PenIcon, PlusIcon, TrashIcon } from "@xola/icons";
import React, { useState } from "react";
import { Schedule } from "types";
import { getDefaultBlackoutScheduleForPackage } from "../../../models/Schedule";
import { BaseScheduleSummary } from "../../BaseSchedule/BaseScheduleSummary";
import { SecondaryButton } from "../../Common/SecondaryButton";
import { ScheduleEditorModal } from "../SchedulesAvailability/ScheduleEditorModal";

interface PackageScheduleEditorProps {
    title: string;
    description: string;
    blackoutSchedules: Schedule[];
    onBlackoutSchedulesChange: (blackoutSchedules: Schedule[]) => void;
}

export const PackageScheduleEditor = ({
    title,
    description,
    blackoutSchedules,
    onBlackoutSchedulesChange,
}: PackageScheduleEditorProps) => {
    const [selectedBlackoutScheduleIndex, setSelectedBlackoutScheduleIndex] = useState<number | null>(null);
    const [showCreateBlackoutScheduleModal, setShowCreateBlackoutScheduleModal] = useState(false);

    const handleCreateBlackoutSchedule = () => {
        setShowCreateBlackoutScheduleModal(true);
    };

    const handleUpdateBlackoutSchedule = (schedule: Schedule) => {
        if (selectedBlackoutScheduleIndex === null) {
            onBlackoutSchedulesChange([...blackoutSchedules, schedule]);
        } else {
            const updatedSchedules = blackoutSchedules.map((blackoutSchedule, index) => {
                return index === selectedBlackoutScheduleIndex ? schedule : blackoutSchedule;
            });

            onBlackoutSchedulesChange(updatedSchedules);
        }
    };

    const handleRemoveBlackoutSchedule = (removeIndex: number) => {
        const updatedSchedules = blackoutSchedules.map((schedule, index) => {
            if (index === removeIndex) {
                return { ...schedule, _remove: true };
            }

            return schedule;
        });
        onBlackoutSchedulesChange(updatedSchedules);
    };

    const selectedBlackoutSchedule =
        selectedBlackoutScheduleIndex === null
            ? getDefaultBlackoutScheduleForPackage()
            : blackoutSchedules[selectedBlackoutScheduleIndex];

    return (
        <div className="space-y-6">
            <div>
                {blackoutSchedules
                    .filter((schedule) => schedule._remove !== true)
                    .map((schedule, index) => (
                        <div
                            // eslint-disable-next-line react/no-array-index-key
                            key={index}
                            className="flex items-center justify-between"
                        >
                            <BaseScheduleSummary showDetails={false} schedule={schedule} />

                            <div className="flex space-x-2">
                                <SecondaryButton size="small" onClick={() => setSelectedBlackoutScheduleIndex(index)}>
                                    <PenIcon />
                                </SecondaryButton>

                                <SecondaryButton size="small" onClick={() => handleRemoveBlackoutSchedule(index)}>
                                    <TrashIcon />
                                </SecondaryButton>
                            </div>
                        </div>
                    ))}

                <div className="flex items-center justify-between">
                    <SecondaryButton icon={<PlusIcon />} size="small" onClick={handleCreateBlackoutSchedule}>
                        Add Blackout Schedule
                    </SecondaryButton>
                </div>
            </div>

            <ScheduleEditorModal
                blackoutSchedules
                returnDateTime
                title={title}
                description={description}
                isOpen={showCreateBlackoutScheduleModal || selectedBlackoutScheduleIndex !== null}
                initialValues={selectedBlackoutSchedule}
                onApply={handleUpdateBlackoutSchedule}
                onClose={() => {
                    setSelectedBlackoutScheduleIndex(null);
                    setShowCreateBlackoutScheduleModal(false);
                }}
            />
        </div>
    );
};
